class CouponSystem {
  constructor() {
    this.selectors = {
      trigger: '.js-coupon-trigger',
      modal: '[data-coupon-modal]',
      modalOverlay: '[data-coupon-overlay]',
      closeButton: '.coupon-modal__close'
    };

    this.classNames = {
      modalActive: 'coupon-modal--active',
      overlayActive: 'coupon-overlay--active',
      triggerLoading: 'coupon-trigger--loading'
    };

    this.init();
  }

  init() {
    this.bindEvents();
  }

  bindEvents() {
    document.querySelectorAll(this.selectors.trigger).forEach(trigger => {
      trigger.addEventListener('click', (e) => this.handleCouponTrigger(e));
    });

    document.querySelectorAll(this.selectors.closeButton).forEach(button => {
      button.addEventListener('click', (e) => this.handleModalClose(e));
    });

    // Close modal when clicking on the modal background (outside the inner content)
    const modal = document.querySelector(this.selectors.modal);
    if (modal) {
      modal.addEventListener('click', (e) => {
        // Only close if the click is directly on the modal element (not its children)
        if (e.target === modal) {
          this.handleModalClose(e);
        }
      });
    }

    // Close modal when clicking on the overlay
    const overlay = document.querySelector(this.selectors.modalOverlay);
    if (overlay) {
      overlay.addEventListener('click', (e) => this.handleModalClose(e));
    }
  }

  async handleCouponTrigger(e) {
    e.preventDefault();
    const trigger = e.currentTarget;
    const code = trigger.dataset.couponCode;

    console.log('Applying coupon code:', code);

    this.setLoadingState(trigger, true);

    try {
      // Make sure the code is not empty
      if (!code || code.trim() === '') {
        console.error('Empty coupon code');
        this.showError('Kein Rabattcode angegeben.');
        return;
      }

      const success = await this.applyCouponCode(code);
      console.log('Coupon application result:', success);

      if (success) {
        this.showSuccessModal();
        // Update cart drawer if it exists
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer && typeof cartDrawer.update === 'function') {
          cartDrawer.update();
        }
      } else {
        this.showError(`Ups! Der Rabattcode ${code} scheint nicht zu funktionieren. Bitte versuchen Sie es erneut oder wenden sich an unseren <a href="/pages/kontaktformular">Kundenservice</a>.`);
      }
    } catch (error) {
      console.error('Error applying discount:', error);
      this.showError(`Ups! Ein technischer Fehler ist aufgetreten. Bitte versuchen Sie es erneut oder wenden sich an unseren <a href="/pages/kontaktformular">Kundenservice</a>.`);
    } finally {
      this.setLoadingState(trigger, false);
    }
  }

  async applyCouponCode(code) {
    console.log('applyCouponCode called with:', code);

    // Uses global applyDiscount function from theme.liquid
    if (typeof window.applyDiscount === 'function') {
      console.log('Using global applyDiscount function');
      const result = await window.applyDiscount(code);
      console.log('Global applyDiscount result:', result);
      return result;
    } else {
      console.log('Global applyDiscount function not found, using fallback');
      // Fallback if the global function doesn't exist
      try {
        const response = await fetch('/discount/' + code);
        console.log('Fallback fetch response:', response);
        return response.ok;
      } catch (error) {
        console.error('Error applying discount:', error);
        return false;
      }
    }
  }

  setLoadingState(trigger, isLoading) {
    trigger.classList.toggle(this.classNames.triggerLoading, isLoading);
  }

  showSuccessModal() {
    const modal = document.querySelector(this.selectors.modal);
    const overlay = document.querySelector(this.selectors.modalOverlay);
    const errorContent = modal.querySelector('[data-coupon-error-content]');
    const successContent = modal.querySelector('[data-coupon-success-content]');

    // Show success content, hide error content
    if (successContent) {
      successContent.style.display = 'flex';
    }
    if (errorContent) {
      errorContent.style.display = 'none';
    }

    if (modal) {
      modal.classList.add(this.classNames.modalActive);
    }

    if (overlay) {
      overlay.classList.add(this.classNames.overlayActive);
    }

    // Prevent body scrolling when modal is open
    document.body.style.overflow = 'hidden';
  }

  handleModalClose(e) {
    e.preventDefault();
    const modal = e.target.closest(this.selectors.modal);
    const overlay = document.querySelector(this.selectors.modalOverlay);

    if (modal) {
      modal.classList.remove(this.classNames.modalActive);

      // Reset modal content after animation completes
      setTimeout(() => {
        const errorContent = modal.querySelector('[data-coupon-error-content]');
        const successContent = modal.querySelector('[data-coupon-success-content]');

        // Default state: success content visible, error content hidden
        if (successContent) {
          successContent.style.display = 'flex';
        }
        if (errorContent) {
          errorContent.style.display = 'none';
        }
      }, 400); // Match the transition duration
    }

    if (overlay) {
      overlay.classList.remove(this.classNames.overlayActive);
    }

    // Restore body scrolling when modal is closed
    document.body.style.overflow = '';
  }

  showError(message) {
    console.error('Coupon error:', message);

    const modal = document.querySelector(this.selectors.modal);
    const overlay = document.querySelector(this.selectors.modalOverlay);
    const errorContent = modal.querySelector('[data-coupon-error-content]');
    const successContent = modal.querySelector('[data-coupon-success-content]');
    const errorMessage = modal.querySelector('[data-coupon-error-message]');

    // Set the error message
    if (errorMessage) {
      errorMessage.innerHTML = message; // Using innerHTML to support HTML links
    }

    // Show error content, hide success content
    if (errorContent) {
      errorContent.style.display = 'flex';
    }
    if (successContent) {
      successContent.style.display = 'none';
    }

    // Show the modal
    if (modal) {
      modal.classList.add(this.classNames.modalActive);
    }

    if (overlay) {
      overlay.classList.add(this.classNames.overlayActive);
    }

    // Prevent body scrolling when modal is open
    document.body.style.overflow = 'hidden';
  }
}

// Initialize
document.addEventListener('DOMContentLoaded', () => {
  window.couponSystem = new CouponSystem();
});
